/**
 * Persists the ProjectNotes panel position and size in localStorage.
 * Follows the same pattern as selectionStorage.js.
 */

const STORAGE_KEY = 'projectNotesPanelState'

const DEFAULT_WIDTH = 520
const DEFAULT_HEIGHT = 620

export { DEFAULT_WIDTH, DEFAULT_HEIGHT }

/**
 * Returns the saved panel state with bounds validation.
 * Clamps position to current viewport so the panel is never off-screen.
 */
export function getSavedPanelState() {
    const defaults = {
        left: null,
        top: null,
        width: DEFAULT_WIDTH,
        height: null,
    }

    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return defaults
        const parsed = JSON.parse(raw)
        const state = { ...defaults, ...parsed }

        // Validate bounds against current viewport
        const vw = window.innerWidth
        const vh = window.innerHeight
        const w = state.width || DEFAULT_WIDTH

        if (state.left !== null) {
            state.left = Math.max(
                0,
                Math.min(state.left, vw - Math.min(w, 100))
            )
        }
        if (state.top !== null) {
            state.top = Math.max(0, Math.min(state.top, vh - 100))
        }

        return state
    } catch {
        return defaults
    }
}

/**
 * Calculates the default centered position for the panel.
 */
export function getDefaultPosition(panelWidth = DEFAULT_WIDTH) {
    return {
        left: 384,
        top: 100,
    }
}

/**
 * Saves the panel state to localStorage.
 * Accepts a partial update — merges with existing state.
 */
export function savePanelState(update) {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        const current = raw ? JSON.parse(raw) : {}
        const merged = { ...current, ...update }
        localStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
    } catch {
        // localStorage unavailable — silently skip
    }
}
